import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Vendedor } from "app/types/Vendedor";
import clsx from "clsx";
import * as R from "ramda";
import React, { useState } from "react";

const estiloAdicionarVendedor = require("./adicionar-vendedor.module.scss").default;
const estiloBotoes = require("./../../../../estilos/botoes.module.scss").default;

export type AdicionarVendedorProps = {
  vendedoresAdicionar: Vendedor[];
  corSelecionado?: string;
  textoSelecionadoAdicionar?: string;
  onIncluirVendedor: () => void;
  onExcluirVendedor: (vendedores: Vendedor[]) => void;
};

const AdicionarVendedor = (props: AdicionarVendedorProps) => {
  const [vendedoresSelecionados, setVendedoresSelecionados] = useState<Vendedor[]>([]);

  const toggleVendedorSelecionado = (vendedor: Vendedor) => {
    if (vendedoresSelecionados.includes(vendedor)) {
      setVendedoresSelecionados(
        R.filter((e) => e != vendedor, vendedoresSelecionados)
      );
    } else {
      setVendedoresSelecionados(vendedoresSelecionados.concat(vendedor));
    }
  }; 

  const botaoIncluir = <button className={clsx('no-global-button', estiloAdicionarVendedor.botao)}
    id="incluir-vendedor"
    onClick={(e) => { props.onIncluirVendedor(); }}>
    <FontAwesomeIcon
      className={estiloAdicionarVendedor.icone_incluir}
      icon={faCirclePlus}
    />Incluir
  </button>

  const botaoExcluir = <button
    className={clsx('no-global-button', estiloAdicionarVendedor.botao)}
    id="excluir-vendedor"
    disabled={vendedoresSelecionados.length === 0}
    onClick={(e) => { props.onExcluirVendedor(vendedoresSelecionados); }}>
    <FontAwesomeIcon
      className={estiloAdicionarVendedor.icone_excluir}
      icon={faTimesCircle}
    />Excluir
  </button>

  const itensTabelaVendedoresSelecionados = <>{props?.vendedoresAdicionar != null && props?.vendedoresAdicionar != undefined && (
    props?.vendedoresAdicionar?.map((vendedor) => {
      return (
        <div
          className={
            vendedoresSelecionados.includes(vendedor)
              ? estiloAdicionarVendedor.linhaSelecionada
              : estiloAdicionarVendedor.linha
          }
          style={
            vendedoresSelecionados.includes(vendedor)
              ? {
                backgroundColor: props.corSelecionado,
                color: props.textoSelecionadoAdicionar,
              }
              : {}
          }
          onClick={() => {
            toggleVendedorSelecionado(vendedor);
          }}
        >
          <div>{vendedor.Codigo}</div>
          <div>{vendedor.Nome}</div>
        </div>
      );
    })
  )}
  </>

  return <>
    <div className="_py-2">
      {botaoIncluir}
      {botaoExcluir}
    </div>

    <div id="tabela-vendedores" className={estiloAdicionarVendedor.tabela}>
      <div>
        <div>Código</div>
        <div>Nome</div>
      </div>
      {itensTabelaVendedoresSelecionados}
    </div>
  </>

};

export { AdicionarVendedor };

